import { useParams } from "react-router-dom";
import React from "react";

export const useEventFromUrl = () => {
  const { congressId } = useParams();
  const eventId = React.useMemo(
    () => (congressId ? parseInt(congressId) : null),
    [congressId]
  );
  return eventId;
};
